export enum MatchState {
  None = 0,
  InProgress = 1,
  Complete = 2,
}
